import { useEffect, useState } from 'react';
import { SCREEN_SIZES } from './useMediaQuery.constants';
import { MediaQueryInput } from './useMediaQuery.types';

export const useMediaQuery = ({ size, customQuery }: MediaQueryInput) => {
  const [hasMatches, setHasMatches] = useState<boolean>(false);

  const query = customQuery || (size ? SCREEN_SIZES[size] : '');

  useEffect(() => {
    if (!query) return;

    const media = window.matchMedia(query);
    const handleSetMatches = () => setHasMatches(media.matches);

    handleSetMatches();

    media.addEventListener('change', handleSetMatches);
    return () => {
      media.removeEventListener('change', handleSetMatches);
    };
  }, [query]);

  useEffect(() => {
    if (typeof window !== 'undefined' && query) {
      setHasMatches(window.matchMedia(query).matches);
    }
  }, [query]);

  return hasMatches;
};